<template>
    <div>
        <div class="row" v-if="records && records.length > 0">
            <div class="col-lg-12" v-if="! showAddPage">
                <div class="col-lg-8">
                    <small class="font-weight-bold">
                        Showing {{ pagination.from == 0 ? 1 : pagination.from }} - {{ pagination.to }} of
                        {{ pagination.total }} entries
                    </small>
                </div>
                <div class="card shadow">

                    <div class="table-responsive">
                        <base-table
                            class="table align-items-center table-flush"
                            thead-classes="thead-light"
                            tbody-classes="list"
                            :data="records"
                        >
                            <template slot="columns">
                                <th width="5%">S/N</th>
                                <th width="30%">School's Name</th>
                                <th width="20%">Quota</th>
                                <th width="25%">Status</th>
                                <th width="20%">Date Modified</th>
                                <th width="10%">&nbsp;</th>
                            </template>

                            <template
                                slot-scope="{row, index}"
                            >
                            <td class="budget">
                                {{ pagination.from+index}}
                            </td>
                            <td class="text-capitalize">
                                {{ row.name ? row.name : 'N/A' }}
                                <br>
                                <badge size="lg"
                                    type="primary"
                                    class="text-uppercase"
                                    v-if="row.accredit_status"
                                >
                                    {{ replaceAll(row.accredit_status, '-', ' ')  }}
                                </badge>
                            </td>
                            <td>
                                {{ row.quota ? row.quota : 'N/A' }}
                            </td>
                            <td>
                                <badge size="lg"
                                    :type="getColor(row.status)"
                                    class="text-capitalize"
                                >
                                    {{ row.status }}
                                </badge>
                            </td>
                            <td>
                                {{ row.updated_at | getDateFormat }}
                            </td>
                            <td>
                                <base-button
                                    :type="getColor(row.status, true)" size="sm"
                                    :disabled="(privileges && privileges.update == 'no') || ! privileges"
                                    @click="makemodifySchoolApiCall(row.id, 'status')"
                                >
                                    <i :class="'fa fa-' +getIcon(row.status)"></i>
                                    {{ (row.status == 'enable') ? 'Deactivate' : 'Activate' }}
                                </base-button>

                                <base-button
                                    type="info" size="sm"
                                    :disabled="(privileges && privileges.update == 'no') || ! privileges"
                                    @click="$emit('editSchool', row)"
                                >
                                    <i class="fa fa-pen"></i> Edit
                                </base-button>

                                <base-button
                                    type="danger" size="sm"
                                    :disabled="(privileges && privileges.delete == 'no') || ! privileges"
                                    @click="modifySchool(row.id, 'delete')"
                                >
                                    <i class="fa fa-trash"></i> Delete
                                </base-button>
                            </td>

                            </template>

                        </base-table>
                    </div>

                    <div
                        class="card-footer d-flex justify-content-end bg-transparent"
                        v-if="hasPagination"
                        @click="paginate"
                    >
                        <base-pagination
                            :total="pagination.total"
                            align="center"
                            v-model="pagination.number"
                            :perPage="pagination.perPage"

                        >
                        </base-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!-- import add accredited school template here -->
        <AddAccreditedSchool
            :data="record"
            :privileges="privileges"
            :loadAccreditedSchools="loadAccreditedSchools"
            v-on:addSchool="addSchool"
            :type="type"
            :all_schools="all_schools"
            v-if="showAddPage"
        />

    </div>
</template>

<script>
    import moment from 'moment';
    import swal from 'sweetalert2';// import sweet alert
    import { mapActions, mapGetters } from 'vuex';
    import AddAccreditedSchool from './AddAccreditedSchool';

    export default {
        name: 'AccreditedSchoolsData',
        props: ["records", "pagination", "hasPagination", "paginate", "privileges", "paginatedItems", "loadAccreditedSchools",
            "showAddPage", "addSchool", "record", "type", "all_schools"],
        components: {
            AddAccreditedSchool
        },
        filters: {
            getDateFormat(value) {
                return value ? moment(value).format('Do MMM, YYYY') : 'N/A';
            }
        },
        computed: {
            ...mapGetters(['user'])
        },
        methods: {
            ...mapActions(['modifyDeleteSchool']),
            replaceAll(str, find, replace) {
                return str.replace(new RegExp(find, 'g'), replace);
            },
            getColor(value, status = false) {
                if(status) {
                    return (value == "enable") ? 'warning' : 'success';
                } else {
                    return (value == "enable") ? 'success' : 'warning';
                }
            },
            getIcon(value) {
                return (value == "enable") ? 'ban' : 'check';
            },
            modifySchool(id, status) {
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Proceed!'
                }).then((result) => {
                    if (result.value) {
                        this.makemodifySchoolApiCall(id, status);// make api call
                    }
                });
            },
            makemodifySchoolApiCall(id, option) {// modify / delete cpd record
                let data = { id : id, option : option, admin_id : this.user.id };
                this.preloader();// show loading
                this.modifyDeleteSchool(data).then((res) => {
                    if(res.status) {
                        let type = (option == 'status') ? 'Modified' : 'Deleted';
                        swal.fire('School '+ type +'!', res.msg, 'success');
                    } else {
                        swal.fire('Error Occurred!', res.msg, 'error');
                    }
                    this.loadAccreditedSchools();// refresh page
                }).
                catch(() => {
                    let msg = "Server Failure, kindly reload the page...";
                    swal.fire('Server Failure!', msg, 'error');
                });
            },
            preloader() {
                return  swal.fire({
                    title: 'Please Wait...',
                    html: 'Trying to fetch data from <b>server</b>',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        }
    }
</script>